import React from "react";
import QRCode from "react-qr-code";

const QRCodeCreator = ({ linkURL }: { linkURL: string }) => (
  <div style={{ padding: "10px 0px" }}>
    <QRCode value={linkURL} size={150} />
  </div>
);
export default QRCodeCreator;
